import { Panel } from "@src/features/experienceBuilder/modifications/common/panel/Panel";

import { InputProps } from "./types";

export const TextInput = ({ label, value, onChange }: InputProps) => (
  <Panel.TextField
    label={label}
    value={value}
    onChange={(e) => onChange(e.target.value)}
  />
);
